import React, { useState } from 'react';
import { Atom, GitBranch, Target, Brain } from 'lucide-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './FocusArea.css';

const FocusAreasSection = () => {
  const focusAreas = [
    {
      icon: <Atom size={48} className="quantum-focus-icon" />,
      title: "Quantum Computing",
      description: "Developing next-generation quantum processors and algorithms."
    },
    {
      icon: <GitBranch size={48} className="quantum-focus-icon" />,
      title: "Quantum Networks",
      description: "Building secure, high-speed quantum communication infrastructures."
    },
    {
      icon: <Target size={48} className="quantum-focus-icon" />,
      title: "Quantum Sensing",
      description: "Enhancing measurement precision across various applications."
    },
    {
      icon: <Brain size={48} className="quantum-focus-icon" />,
      title: "Quantum AI",
      description: "Exploring the intersection of quantum computing and artificial intelligence."
    }
  ];

  const stats = [
    { number: "500+", label: "Active Members" },
    { number: "20+", label: "Themed events" },
    { number: "10+", label: "Industry Partners" }
  ];

  const [focusIndex, setFocusIndex] = useState(0);
  const [statsIndex, setStatsIndex] = useState(0);

  const nextFocus = () => setFocusIndex((prev) => (prev + 1) % focusAreas.length);
  const prevFocus = () => setFocusIndex((prev) => (prev - 1 + focusAreas.length) % focusAreas.length);

  const nextStat = () => setStatsIndex((prev) => (prev + 1) % stats.length);
  const prevStat = () => setStatsIndex((prev) => (prev - 1 + stats.length) % stats.length);

  return (
    <div className="quantum-focus-section">
      <div className="quantum-focus-container">

        {/* Community Highlights */}
        <div className="quantum-community-section">
          <h2 className="quantum-focus-section-title">Community Highlights</h2>

          <div className="quantum-stats-slider">
            <button onClick={prevStat} className="slider-arrow">
              <ChevronLeft />
            </button>
            <div className="quantum-stat-card">
              <div className="quantum-stat-number">{stats[statsIndex].number}</div>
              <div className="quantum-stat-label">{stats[statsIndex].label}</div>
            </div>
            <button onClick={nextStat} className="slider-arrow">
              <ChevronRight />
            </button>
          </div>

          <div className="quantum-stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="quantum-stat-card">
                <div className="quantum-stat-number">{stat.number}</div>
                <div className="quantum-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Key Focus Areas */}
        <h2 className="quantum-focus-section-title">Core Disciplines</h2>

        <div className="quantum-focus-slider">
          <button onClick={prevFocus} className="slider-arrow">
            <ChevronLeft />
          </button>
          <div className="quantum-focus-card">
            {focusAreas[focusIndex].icon}
            <h3 className="quantum-focus-card-title">{focusAreas[focusIndex].title}</h3>
            <p className="quantum-focus-card-description">{focusAreas[focusIndex].description}</p>
          </div>
          <button onClick={nextFocus} className="slider-arrow">
            <ChevronRight />
          </button>
        </div>

        <div className="quantum-focus-grid">
          {focusAreas.map((area, index) => (
            <div key={index} className="quantum-focus-card">
              {area.icon}
              <h3 className="quantum-focus-card-title">{area.title}</h3>
              <p className="quantum-focus-card-description">{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FocusAreasSection;
